/**
 * view for list with delayed publications
 * extends admin-dashboard-list-base view
 **/
import BaseView from '../admin-dashboard-list-base/view';
import EventBus from '../../utils/eventbus';
import SocketEvents from '../../events/socket';

export default BaseView.extend({
	initialize: function() {
		// call BaseView constructor
		var collectionData = window.delayedPublicationsData || null;
		BaseView.prototype.initialize.apply(this, [collectionData]);

		// listen to new notifications, call BaseView method
		this.listenTo(EventBus, SocketEvents.DELAYEDPUBLICATION, this.onNotificationReceived);
	}
});
